import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {
  NgbModal,
  NgbModalOptions,
  NgbDatepickerConfig
} from "@ng-bootstrap/ng-bootstrap";
import {Store} from "@ngrx/store";
import {SetPatientAction} from "../../actions";
import {
  AuthService,
  PatientService,
  UtilService,
  DuplicateFinderService
} from "../../services";
import { Subscription } from "rxjs/Subscription";
import * as moment from "moment";
import {Ethnicity} from "../../models/ethnicity";
import {EthnicityService} from "../../services/ethnicity/ethnicity.service";
import {RegexPattern} from "../../models";

@Component({
  selector: "app-patient-details-modal",
  templateUrl: "./patient-details-modal.component.html",
  styleUrls: ["./patient-details-modal.component.scss"]
})
export class PatientDetailsEditModalComponent
  implements OnInit, AfterViewInit, OnDestroy, AfterContentChecked {
  @ViewChild("content") template: TemplateRef<any>;

  public states: Array<USState>;
  public modalRef: any;
  public patient: any;
  public confirm: boolean = false;
  public editMode: boolean = true;
  public modalTitle = "Edit Patient";
  public isOfficeStaff: any;

  public regexModel: RegexPattern;

  private patientId: any;
  private isAdminEdit: boolean = false;

  // exit edit/* workflow
  private cancelPath: string = "../../";

  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-details",
    keyboard: false
  };
  private subscriptions: { [name: string]: Subscription } = {};
  public dateOfBirth: { year: number; month: number; day: number };
  private mode: string;
  public currentDate = moment().format("YYYY-MM-DD");
  public dobYear: any;
  public dobMonth: any;
  public dobDay: any;
  public futureDate: any;
  public minYear: boolean;
  public ethnicities: Array<Ethnicity> = [];

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private duplicateFinderService: DuplicateFinderService,
    private store: Store<any>,
    private authService: AuthService,
    private config: NgbDatepickerConfig,
    private ethnicityService: EthnicityService
  ) {
    // customize default values of datepickers used by this component tree
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    // customize default values of datepickers used by this component tree
    this.config.minDate = {year: 1900, month: 1, day: 1};
    this.config.maxDate = {year, month, day};
    // days that don't belong to current month are not visible
    this.config.outsideDays = "hidden";
    this.regexModel = new RegexPattern();
  }

  cancel() {
    this.router.navigate([this.cancelPath], {relativeTo: this.route});
  }

  ngOnInit() {
    this.ethnicityService.getEthnicity().subscribe(values => {
      this.ethnicities = values;
    });

    this.mode = "edit-mode";
    this.subscriptions["patient"] = this.store
      .select("patient")
      .subscribe(data => {
        this.patient = Object.assign({}, this.patient, data);
        let dob = this.patient.Dob ? moment(new Date(this.patient.Dob)).format('MM-DD-YYYY').split('-') : null;
        dob !== null
          ? (this.dateOfBirth = {
            month: Number(dob[0]),
            day: Number(dob[1]),
            year: Number(dob[2])
          })
          : (this.dateOfBirth = null);
      });

    this.subscriptions[
      "params"
      ] = this.route.parent.parent.parent.params.subscribe(params => {
      this.patientId = params["id"];
    });

    this.subscriptions["route"] = this.route.parent.parent.data.subscribe(
      data => {
        if (data.isAdminEdit) {
          this.isAdminEdit = data.isAdminEdit;

          // admin-portal does not have a /patients/:id path, only a /patients.  let's trim off that :id
          this.cancelPath = "../../../";
        }
      }
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  ngAfterContentChecked() {
    let currentDateObject = this.currentDate.split("-");
    this.dobYear = Number(currentDateObject[0]);
    this.dobMonth = Number(currentDateObject[1]);
    this.dobDay = Number(currentDateObject[2]);
    if (this.dateOfBirth) {
      this.minYear = this.dateOfBirth.year < this.config.minDate.year;
      this.futureDate = this.dateOfBirth.year > this.dobYear || (this.dateOfBirth.year == this.dobYear && this.dateOfBirth.month > this.dobMonth)
        || (this.dateOfBirth.year == this.dobYear && this.dateOfBirth.month == this.dobMonth && this.dateOfBirth.day > this.dobDay);
    }
  }

  setConfirm() {
    this.confirm = false;
  }

  checkFormValidity(form) {
    let detectNonAlphaRegex = /[^a-zA-Z]/g;
    return form.invalid || detectNonAlphaRegex.test(this.patient.MiddleName) || this.futureDate || this.minYear;
  }

  createUpdatePatient() {
    this.duplicateFinderService.confirmDuplicatePatient(
      this.dateOfBirth,
      this.patient,
      this.mode,
      this.patientId
    );
    this.router.navigate(["../additional-details"], {
      relativeTo: this.route
    });
  }

  isString(val) {
    return typeof val === "string";
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });

    for (let sub in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(sub)) {
        this.subscriptions[sub].unsubscribe();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/patient-details-modal/patient-details-edit-modal.component.ts